module.exports = "<div class=\"ot-separator\"\n  ng-class=\"{'ot-vertical': params.type != 'horizontal', 'ot-horizontal': params.type == 'horizontal'}\">\n  <div></div>\n    <p ng-show=\"params.text.length && params.text.length > 0\">{{params.text | translate}}</p>\n  <div></div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/common/separator.html
 ** module id = 255
 ** module chunks = 1
 **/